import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { contentLanguagesSelector } from "@skilitics/nautilus-core-designer-data";

/**
 * The module's content languages as pickable options: the content language's own
 * code — what the runtime means by `locale`, and what `changeActiveLanguage`
 * carries — under the language's title, which is the only form worth showing an
 * author.
 *
 * The two differ for a regional variant (`en-NZ` of `English`), so the code is
 * taken from the content language and never from the language behind it.
 */
export const localeOptionsSelector = createSelector([contentLanguagesSelector], (contentLanguages) =>
  contentLanguages.map((contentLanguage) => ({
    value: contentLanguage.code,
    label: contentLanguage.language.title,
  })),
);

export const useLocaleOptions = () => useSelector(localeOptionsSelector);
